import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../context/themeContext";
import { useSelector } from "react-redux";

const SkillStatus = () => {
  const { theme } = useTheme();
  const { activeUserSkill } = useSelector((state) => state.user);

  return (
    <Box
      className={styles.skillsCommunityStatus}
      sx={{
        background: theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Box className={styles.skillsItem}>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.darkgrey.darkgrey600,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Category
        </Typography>
        <Box className={styles.tags}>
          {activeUserSkill?.category ? (
            <Chip label={activeUserSkill?.category} />
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.darkgrey.darkgrey400,
              }}
            >
              No category selected yet!
            </Typography>
          )}
        </Box>
      </Box>
      <Box className={styles.skillsItem}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.darkgrey.darkgrey600,
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            Skill
          </Typography>
        </Box>
        <Box className={styles.tags}>
          {activeUserSkill?.name ? (
            <Chip label={activeUserSkill?.name} />
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.darkgrey.darkgrey400,
              }}
            >
              No skill selected yet!
            </Typography>
          )}
        </Box>
      </Box>
      <Box className={styles.skillsItem}>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.darkgrey.darkgrey600,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Specialty
        </Typography>
        <Box className={styles.tags}>
          {activeUserSkill?.speciality ? (
            <Chip label={activeUserSkill?.speciality} />
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.darkgrey.darkgrey400,
              }}
            >
              No specialty selected yet!
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SkillStatus;
